// const placeholder = {
//   alt: "1",
//   src: "https://dl.dropboxusercontent.com/s/v2bcml1omnu6lu3/a0269257710_10.jpg"
// };
// const convert = url =>
//   url
//     .replace(/https:\/\/www.dropbox\.com/, "https://dl.dropboxusercontent.com")
//     .replace(/\?dl=0/, "");
export const projects = [
  {
    title: "designing the code",
    description:
      "Designing the code is a self-initiated project started to expand my understanding of React animations & design-to-code skills. While working on this project, I learned the importance of planning different code structures before writing the first line of code. And even better, i met some really talented and awesome designers who allowed me to bring their designs to life :)",
    position: "Front-end developer",
    short:
      "A self-initiated project aiming to study performant animation & its component estructure in react",
    tag: "self-initiated",
    library: { npm: "react", import: "React" },
    technologies: [
      "React",
      "Styled Components",
      "Rebass",
      "Animejs",
      "React Spring"
    ],
    color: "accentBlue",
    cover: {
      alt: "Designing the code cover",
      src: "https://dl.dropboxusercontent.com/s/p9wd53zd0rj3wq1/DTC-cover.jpg"
    },
    features: [
      {
        title: "Route shared component",

        imageLeft: {
          alt: "simple shared component",
          src:
            "https://dl.dropboxusercontent.com/s/y4hpw1161ljdacq/DTC-shared-simple.gif"
        },
        imageRight: {
          alt: "final shared component",
          src:
            "https://dl.dropboxusercontent.com/s/8zqxicnmv6ok8pv/DTC-shaded-final.gif"
        }
      }
    ],
    gallery: [
      {
        alt: "About component",
        src:
          "https://dl.dropboxusercontent.com/s/09ww35hla8eqk2p/DTC-gallery-1.jpg"
      },
      {
        alt: "footer component",
        src:
          "https://dl.dropboxusercontent.com/s/588x8sjd2fqxpcx/DTC-gallery-2.jpg"
      },
      {
        alt: "Catalog component",
        src:
          "https://dl.dropboxusercontent.com/s/a8trghln8hej12h/DTC-gallery-3.jpg"
      },
      {
        alt: "magazine component",
        src:
          "https://dl.dropboxusercontent.com/s/9oo5969j0fca62f/DTC-gallery-4.jpg"
      }
    ]
  },
  {
    title: "Chemistry web-games",
    description:
      "As a contractor, I helped develop several games for teaching chemistry to children in Chile. My job was to take the designs and code their inner workings using the minimal amount of 3rd party code possible to meet with the project's bundle size limit.",
    short:
      "A series of interactive games for teaching chemical elements & interactions to children in Chile.",
    position: "React developer",
    tag: "Freelancing",
    library: { npm: "react", import: "React" },
    technologies: ["React", "SVG"],
    color: "mustard",
    cover: {
      alt: "Chemestry slide cover",
      src:
        "https://dl.dropboxusercontent.com/s/bfud9sbpzjeo0y8/quimico-gallery-4.png"
    },
    gallery: [
      {
        alt: "elements table view",
        src:
          "https://dl.dropboxusercontent.com/s/nb7kn8jx2vzszt2/elemento-gallery-1.jpg"
      },
      {
        alt: "Elements table question view",
        src:
          "https://dl.dropboxusercontent.com/s/eakf5fcgmpmgaw4/elemento-gallery-2.jpg"
      },
      {
        alt: "Elements in the kitchen main view",
        src:
          "https://dl.dropboxusercontent.com/s/fp57ujdgt75pwmi/quimico-gallery-1.jpg"
      },
      {
        alt: "Elements in the kitchen object closeup",
        src:
          "https://dl.dropboxusercontent.com/s/3jmgnfn23vv0dhm/quimico-gallery-2.jpg"
      }
    ]
  },
  {
    title: "design katalog",
    description:
      "Working together with NeverTired agency, we developed the redesign of designkatalog's website. Designkatalog is an interior design company based in Germany, which aims to increase the quality of life and work. As part of the coding team, my job was to develop responsive React components that were fast, accessible & maintainable, some of which were animated.",
    short:
      "A collaboration with NeverTired agency focused on developing designkatalog's website.",
    position: "Front-end developer",
    tag: "Never-Tired",
    library: { npm: "react", import: "React" },
    technologies: [
      "React",
      "Redux",
      "Bootstrap",
      "Styled Components",
      "Animejs"
    ],
    color: "accentGreen",
    cover: {
      alt: "design katalog cover",
      src:
        "https://dl.dropboxusercontent.com/s/99v382wzr451zi5/katalog-cover.png"
    },
    features: [
      {
        title: "Main Gallery",
        imageLeft: {
          alt: "katalog carousel simple",
          src:
            "https://dl.dropboxusercontent.com/s/g95emn7zyndr4q8/katalog-carousel-simple.gif"
        },
        imageRight: {
          alt: "katalog carousel final",
          src:
            "https://dl.dropboxusercontent.com/s/1b4dzw6xmpnh4nk/katalog-carousel-final.gif"
        }
      }
    ],
    gallery: [
      {
        alt: "About component",
        src:
          "https://dl.dropboxusercontent.com/s/gp6v0h3kc0djivo/katalog-gallery-1.jpg"
      },
      {
        alt: "footer component",
        src:
          "https://dl.dropboxusercontent.com/s/38oe5msaviwsi2s/katalog-gallery-2.jpg"
      },
      {
        alt: "Catalog component",
        src:
          "https://dl.dropboxusercontent.com/s/l5p1jy2sbkwizgf/katalog-gallery-3.jpg"
      },
      {
        alt: "magazine component",
        src:
          "https://dl.dropboxusercontent.com/s/amhdf8y7d5g1dhu/katalog-gallery-4.jpg"
      }
    ]
  },
  {
    title: "Portafolio redesign",
    description:
      "As part of my growth as a Front-end development, a redesign of my personal brand was needed. Since i developed my last portfolio, I've grown as a developer and as a person. To reflect my personal and professional change, i decided to rebrand myself. So, I decided to design and code it myself.",
    short: "Redesign and development of my personal brand & website.",
    position: "Designer & developer",
    tag: "Portafolio",
    library: { npm: "styled", import: "styled-components" },
    technologies: [
      "React",
      "React Router",
      "Styled components",
      "Styled Systems",
      "React Spring"
    ],
    color: "accentRed",
    cover: {
      alt: "Redesign slide cover",
      src:
        "https://dl.dropboxusercontent.com/s/ud42dkyx2uaxy5h/portafolio-cover.png"
    },
    gallery: [
      {
        alt: "Website rebrand about",
        src:
          "https://dl.dropboxusercontent.com/s/slzmnuehm4wwfr0/portafolio-gallery-1.png"
      },
      {
        alt: "Website rebrand homescreen",
        src:
          "https://dl.dropboxusercontent.com/s/0iogcvpcisitxbg/portafolio-gallery-2.jpg"
      },
      {
        alt: "Old website homescreen",
        src:
          "https://dl.dropboxusercontent.com/s/zijmjlve951irea/portafolio-gallery-3.jpg"
      },
      {
        alt: "Website rebrand about page",
        src:
          "https://dl.dropboxusercontent.com/s/ifj3xvm3hqp4zed/portafolio-gallery-4.jpg"
      }
    ]
  }
].map(c => {
  c.id = c.title.split(" ").join("-");
  return c;
});
// https://designkatalog.com/
